module.exports = __webpack_public_path__ + "img/bg (2).341b7ec5.jpg";